export const getThreadsUrl = '/user/chat/thread';
export const getChatUrl = '/message/getChat';
export const createMessageUrl = '/message/createMessage';
